import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

const baseURL = `http://natlres05.jfrn.jus.br:8005/chatbot`

@Injectable({
  providedIn: 'root'
})
export class ChatGptService {

  tokenConversa: any
  chatObserver = new Subject<any>();
  dadosRespostaMsg: any;
  evento!: IEvento;
  respConversa: any

  constructor(private http: HttpClient) { }

  getChatObserver(): Observable<any> {
    return this.chatObserver.asObservable();
  }

  closeChat() {
    this.evento = { nomeEvento: "fechar", mensagensRobo: null }
    this.chatObserver.next(this.evento);
  }

  hideChat() {
    this.evento = { nomeEvento: "ocultar", mensagensRobo: null }
    this.chatObserver.next(this.evento);
  }

  openChat() {
    this.evento = { nomeEvento: "abrir", mensagensRobo: this.dadosRespostaMsg }
    this.chatObserver.next(this.evento);
  }

  notificaNovaMsg(msg: any) {
    this.evento = { nomeEvento: "novaMsg", mensagensRobo: msg }
    this.chatObserver.next(this.evento);
  }

  notificaMsgInicialRobo(msg: any) {
    this.evento = { nomeEvento: "msgInicial", mensagensRobo: msg }
    this.chatObserver.next(this.evento);
  }

  enviarMensagem(mensagem: string) {
    const data = {
      "sender": "Usuário",
      "message": mensagem,
    };
  
    this.http.post(`${baseURL}`, data).subscribe(
      (resp: any) => {
        if (Array.isArray(resp) && resp.length === 0) {
          this.notificaNovaMsg("Nenhuma mensagem encontrada."); // Mensagem padrão para matriz vazia
        } else if (resp === null || resp === '') {
          this.notificaNovaMsg("Resposta vazia."); // Mensagem padrão para nulo ou vazio
        } else if (Array.isArray(resp)) {
          console.log("chamou resp array");
          resp.forEach((message) => {
            this.notificaNovaMsg(message);
            console.log(message);
          });
        } else if (resp != undefined) {
          console.log("chamou resp normal");
          this.notificaNovaMsg(resp);
          console.log(resp);
        }else{
          console.log("chamou gpt");
          this.getChatGpt(mensagem);
        }
      },
      (err) => { }
    );
  }
  

  getChatGpt(mensagem: any) {
    console.log("chamou GPT"); 

    const data = {
      "message": mensagem,     
    };

    // Defina os cabeçalhos apropriados para 'form-data'
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });

    return this.http.post(`http://natlres05.jfrn.jus.br:8005/chatbot`, data, { headers })
      .subscribe(
        (resp: any) => {
          // Se a resposta for um JSON, você pode acessar os dados diretamente
          this.respConversa = resp;
          console.log("Resposta", resp);
          this.notificaNovaMsg(resp);
        },
        err => {
          console.log("Error", err);
          // Lide com o erro aqui, se necessário
        }
      )
  }
}


interface IEvento {
  nomeEvento: string;
  mensagensRobo: any;
}

interface IMensagem {
  CriaConversa: string;
  Token: string;
  NomeUsuario: number;
  CpfUsuario: number;
  TelefoneUsuario: number;
  EmailUsuario: number;
}
